import {
  ICheckoutItem,
  ICheckoutItemData
} from './index'

export class CheckoutItem implements ICheckoutItem {
  readonly price: string
  readonly quantity: number

  constructor(data: ICheckoutItemData) {
    this.price = data.stripe_price
    this.quantity = data.quantity || 1
  }
}